import { SerializableObject } from '../../common-react/core';

/**
 * Similar to Partial<T>, but all nested SerializableObject instances are also Partial.
 *
 * @see Partial
 */
export type PartialSerializableObject<T> = {
  [P in keyof T]?: T[P] extends SerializableObject ? PartialSerializableObject<T[P]> | undefined : T[P] | undefined;
};
